import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readOptionalNumber,
  readString,
  splitKnown,
} from "../utils";

export class ProductVersionFactoryPricingLargeSizeModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    sizeName: { label: "Size Name", fieldType: "text" },
    price: { label: "Price", fieldType: "number", allowNull: true },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  sizeName!: string;
  price!: number | null;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("sizeName", "");
    this.defineObservableValue("price", null);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product factory pricing large size");
    this.sizeName = readString(source, "sizeName");
    this.price = readOptionalNumber(source, "price");
    this.extra = splitKnown(source, ["sizeName", "price"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.sizeName ? { sizeName: this.sizeName } : {}),
      ...(this.price === null ? {} : { price: this.price }),
    };
  }
}
